import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HomeLanding from './pages/home-landing';
import BookingEngine from './pages/booking-engine';
import AccommodationDetails from './pages/accommodation-details';
import PhotoGallery from './pages/photo-gallery';
import ActivitiesExperiences from './pages/activities-experiences';
import ContactDirections from './pages/contact-directions';
import ResortsOverview from './pages/resorts-overview';
import PackageDetails from './pages/package-details';
import FeaturedExperiencesHub from './pages/featured-experiences-hub';
import InvoicePage from './pages/InvoicePage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<HomeLanding />} />
          <Route path="/home-landing" element={<HomeLanding />} />
          <Route path="/booking-engine" element={<BookingEngine />} />
          <Route path="/accommodation-details" element={<AccommodationDetails />} />
          <Route path="/photo-gallery" element={<PhotoGallery />} />
          <Route path="/activities-experiences" element={<ActivitiesExperiences />} />
          <Route path="/contact-directions" element={<ContactDirections />} />
          <Route path="/resorts-overview" element={<ResortsOverview />} />
          <Route path="/package-details" element={<PackageDetails />} />
          <Route path="/featured-experiences-hub" element={<FeaturedExperiencesHub />} />
          <Route path="/invoice" element={<InvoicePage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;